// extracted by mini-css-extract-plugin
export default {"alertContainerInfoContainer":"AlertProvider--alertContainerInfoContainer--lP1o8","alertContainerInfo":"AlertProvider--alertContainerInfo--w-NvX"};